<template>
  <div class="test">
    <h2>Kasir Detail</h2>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: "Test",
  components: {},
};
</script>